import TextInput from '~/components/TextInput';
import {
    DEFAULT_LOGIN_DESCRIPTION,
    DEFAULT_SKIP_DESCRIPTION,
} from '~/components/forms/questions/components/ClientLogin';

const EditClientAccountForm = ({ settings, setSettings }) => {
    return (
        <div className="mt-4">
            <div>
                Allow clients to log in and see their history. Clients verify
                their email address to get access.
            </div>
            <div className="mt-2 mb-6">
                Making this required ensures that clients must log in to submit
                this form.
            </div>
            <TextInput
                onChange={value =>
                    setSettings({ ...settings, loginDescription: value })
                }
                value={settings?.loginDescription || ''}
                label="Description"
                placeholder={DEFAULT_LOGIN_DESCRIPTION}
            />
            <TextInput
                onChange={value =>
                    setSettings({ ...settings, skipDescription: value })
                }
                value={settings?.skipDescription || ''}
                label="Skip Description"
                placeholder={DEFAULT_SKIP_DESCRIPTION}
                className="mt-4"
            />
        </div>
    );
};

export default EditClientAccountForm;
